import styled from 'styled-components';
import { breakpoints } from '../../../../styles/theme';
import { BasketPaymentDetailsStyled } from '../BasketPaymentDetailsStyled';
import { rem } from 'polished';

export const BasketPaymentDetailsAC = styled(BasketPaymentDetailsStyled)`
    .cashSummary {
        color: ${({ theme }) => theme.colors.grey5};
    }

    .financeSummary {
        border-radius: ${rem(12)};
        background: ${({ theme }) => theme.colors.grey6};
        color: ${({ theme }) => theme.colors.grey5};

        .monthlyPaymentSummary {
            .monthlyPaymentItem {
                .price {
                    font-weight: ${({ theme }) => theme.fontWeights.textRegular};
                }
            }
        }

        .monthlyPaymentDesktop {
            font-size: ${rem('20px')};
            align-items: baseline;
        }

        .infoIcon {
            svg {
                g {
                    circle {
                        fill: ${({ theme }) => theme.colors.grey2};
                        stroke: ${({ theme }) => theme.colors.grey2};
                    }

                    line {
                        stroke: ${({ theme }) => theme.colors.white};
                    }
                }
            }
        }

        .personalizeButton {
            font-size: ${({ theme }) => theme.fontSizes.h4};
            color: ${({ theme }) => theme.colors.blue2};
            border: 2px solid ${({ theme }) => theme.colors.blue2};
            border-radius: ${rem(24)};
            &:hover {
                color: ${({ theme }) => theme.colors.black};
                border-color: ${({ theme }) => theme.colors.black};
                background: unset;
            }
            
            @media (max-width: ${breakpoints.md}px) {
                font-size: ${({ theme }) => theme.fontSizes.h5};
            }
        }
    }

    .legalText {
        p {
            font-size: ${({ theme }) => theme.fontSizes.h6};
            color: ${({ theme }) => theme.colors.grey1};
        }
    }

    .titleWrapper {
        color: ${({ theme }) => theme.colors.grey5};
    }

    .description {
        color: ${({ theme }) => theme.colors.grey5};

        .linkText {
            padding-bottom: unset;
        }
    }
`;
